import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ImportPayload, ImportResponse } from './components/cxone-custom-data-import-dialog/cxone-custom-data-import-dialog.model';
import { CustomerImportList } from './cxone-etl-data-imports-model';
import { ListViewObj } from './components/cxone-custom-data-import-view/cxone-custom-data-import-view-model';

@Injectable({
    providedIn: 'root'
})
export class CxoneEtlDataImportService {
    baseImportURL = '/api/v1/customdata/import';
    constructor(
        private cvApiService: CVApiService,
    ) { }

    public async customDataImport() {
        try {
            const response = await this.cvApiService.get<CustomerImportList>(this.baseImportURL);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }

    public async importFile(payload: ImportPayload): Promise<ImportResponse> {
        try {
            const response = await this.cvApiService.post<ImportResponse>(this.baseImportURL, payload);
            if (response.status_code >= 200 && response.status_code < 300 && response.data)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }

    public async loadViewData(importID: string) {
        try {
            const response = await this.cvApiService.get<ListViewObj[]>(`${this.baseImportURL}/${importID}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }

    async deleteListItemById(id: string) {
        try {
            const response = await this.cvApiService.delete<void>(`${this.baseImportURL}/${id}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }

    async deleteSelectedViewitems(payload) {
        try {
            const response = await this.cvApiService.put<void>(`/api/v1/customdata/delete_rows`, payload);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }

    async getPermissions(requestedPage:string) {
        try {
            const response = await this.cvApiService.get<string[]>(`/api/v1/general/pages/user-permissions/${requestedPage}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }
}
